export default function PlaySound({path}:{path:string}){
    // create a component to play sound file
    return (
        <audio controls src={path}>
            Your browser does not support the audio element.
        </audio>
    )
    
}